import React, { createContext, useContext, useState } from 'react';

import AccountSelectorModal from './AccountSelectorModal';

interface OpenAccountSelectorModalParameter {
  onUpdateAccountSuccess?: (() => void) | (() => Promise<void>);
}

interface AccountSelectorModalContextValue {
  openAccountSelectorModal: (
    parameter: OpenAccountSelectorModalParameter,
  ) => void;
}
const AccountSelectorModalContext =
  createContext<AccountSelectorModalContextValue | null>(null);

interface AccountSelectorModalProviderState
  extends OpenAccountSelectorModalParameter {
  isOpen: boolean;
}

export default function AccountSelectorModalProvider({
  children,
}: React.PropsWithChildren<{}>) {
  const [state, setState] = useState<AccountSelectorModalProviderState>(null);

  async function handleUpdateAccountSuccess() {
    if (state?.onUpdateAccountSuccess) {
      await state.onUpdateAccountSuccess();
    }
    setState(null);
  }

  function openAccountSelectorModal({
    onUpdateAccountSuccess,
  }: OpenAccountSelectorModalParameter) {
    setState({
      isOpen: true,
      onUpdateAccountSuccess,
    });
  }

  return (
    <AccountSelectorModalContext.Provider value={{ openAccountSelectorModal }}>
      {children}
      <AccountSelectorModal
        isOpen={state?.isOpen}
        onUpdateAccountSuccess={handleUpdateAccountSuccess}
      />
    </AccountSelectorModalContext.Provider>
  );
}

export function useAccountSelectorModal() {
  const context = useContext(AccountSelectorModalContext);
  if (!context) {
    throw new Error(
      'useAccountSelectorModal should be used inside AccountSelectorModalProvider',
    );
  }
  return context;
}
